export default __webpack_public_path__ + "static/media/clock.1101bc89.svg";